export default __webpack_public_path__ + "static/media/robot-purple.a77befa1.svg";